import { Transition, Disclosure } from '@headlessui/react'
import { ArrowCircleRightIcon } from '@heroicons/react/outline'
import Link from 'next/link'
import Image from 'next/image';

export default function Faq() {
  return (
    <section className="relative bg-white bg-center overflow-hidden font-['Inter']">
      <div className="bg-transparent">
        <div className="relative pt-16 pb-12">
          <div className="container px-4 md:px-0 mx-auto max-w-3xl lg:max-w-5xl">
            <div className="w-full relative z-10 flex flex-wrap justify-center -mx-4">
              <div className="w-full px-4 mb-12 md:mb-0 text-center">
                <h1
                  className="w-full mx-auto main-top-title mb-16">
                  Frequently Asked Questions<br />
                </h1>
                <div>
                  <div className="w-full px-10">
                    <div className="flex flex-col md:items-left items-center justify-center text-left w-full">
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">What type of support packages do you offer?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter  rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">We offer four different support packages: Bronze, Silver, Gold, and Platinum. Each package offers different levels of support and is priced accordingly. <Link className="underline" href="/pricing">See more</Link>
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">How quickly can you respond?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter  rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">While we strive to respond quickly to all support requests, please be aware that the response time may differ based on the support package you choose. Our Bronze package offers a 48-hour response time for email support, while our Silver package offers a 24-hour response time for online support. Our Gold package offers an 8-hour response time for phone/online/screen-share support, and our Platinum package offers a 4-hour response time for phone/online/screen-share support. We are committed to providing fast and efficient support to all of our customers within these response times, and our team is always available to help you with any questions or issues you may have.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">Do you offer customized support packages based on my specific needs?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter  rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      We are always open to discussing customized support options that are tailored to your specific requirements. We pride ourselves on being a flexible and adaptable support provider, and we are always happy to explore new options and solutions to help our customers achieve their goals. If you are interested in discussing custom support options, we encourage you to <Link className="underline" href="/contact">contact us</Link> directly.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">What’s the mechanism to get support?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter  rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel>
                                <div className="flex">
                                  <div className="">
                                    <p className="mx-auto w-full text-secgray text-justify font-regular mb-8">
                                      The mechanism to get support depends on the specific support package you have purchased. If you have purchased our Bronze support package, support is provided via email. Our Silver, Gold, and Platinum support packages offer more comprehensive support options, including online chat and screen-share support. Additionally, our Gold and Platinum support packages also include phone support during specific hours. For more information on our support packages and the specific support options that are included, see our <Link className="underline" href="/pricing">pricing page</Link>. If you have any questions about our support options or need assistance selecting the package that is right for you, you can  <Link className="underline" href="/support">contact us</Link> directly. Our team is always available to help.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                      <Disclosure className="w-full">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="w-full min-w-full mb-8">
                              <div className="flex justify-between mb-2 md:mb-0 text-maingray items-center">
                                <h3 className="text-md md:text-xl lg:text-[22px] text-maingray font-semibold text-start">How do you handle support requests outside of your regular support hours?</h3>
                                <Image width={24} height={24} src="/assets/icons/arrow-circle.png" className={open ? 'bypass-filter  rotate-90 shrink-0 w-6 ml-auto transform text-orange-400' : 'shrink-0 w-6 ml-auto text-orange-400'} alt="Dropdown Arrow"/>
                              </div>
                            </Disclosure.Button>
                            <Transition
                              enter="transition duration-100 ease-out"
                              enterFrom="transform scale-95 opacity-0"
                              enterTo="transform scale-100 opacity-100"
                              leave="transition duration-75 ease-out"
                              leaveFrom="transform scale-100 opacity-100"
                              leaveTo="transform scale-95 opacity-0"
                            >
                              <Disclosure.Panel className="w-full">
                                <div className="flex justify-start w-full">
                                  <div className="w-full">
                                    <p className="w-full text-secgray text-start font-regular mb-8">
                                      We are a globally distributed team. That enables us to provide support 24/7 for our customers. Contact us <Link className="underline" href="/contact">here</Link> for more information.
                                    </p>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </Transition>
                          </>
                        )}
                      </Disclosure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
